
// decorator
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// mixins
import ResizeMixin from '../mixins/resize'
import ChartRenderMixin from '../ccg/mixins/ChartRenderMixin'

@Component({
  name: 'SingleBarChart'
})
export default class extends mixins(ResizeMixin, ChartRenderMixin) {
  created() {
    this.BASE_CONFIG = {
      grid: {
        top: '8%',
        left: '5%',
        right: '5%',
        bottom: '5%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        axisTick: {
          alignWithLabel: true
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        axisLine: {
          show: true,
          lineStyle: {
            color: '#999'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#999'
          }
        },
        scale: true
      }
    }
  }
}
